let featuredArticle = {};
let isInitialized = false, $slider = $('.js-featured-article');

featuredArticle.init = () => {
  if(!$slider) return;
  let elChildLength = $slider.children().length;

  $slider.flickity({
    pageDots: (elChildLength > 1) ? true : false,
    contain: true,
    cellAlign: 'left',
    percentPosition: false,
    dragThreshold: 10,
    prevNextButtons: false,
    groupCells: false,
    wrapAround: false,
    freeScroll: true,
    on: {
      ready: function() {
        if(window.innerWidth < 979) {
          isInitialized = true;
        } else {
          isInitialized = false;
        }
      },
    },
  });

  if(window.innerWidth < 979) {
    isInitialized = true;
  } else {
    isInitialized = false;
  }

  if(!isInitialized) {
    $slider.flickity('destroy');
  }
};

document.addEventListener('DOMContentLoaded', () => {
  featuredArticle.init();
  window.addEventListener('resize', () => {
    featuredArticle.init();
  });
});



// WEBPACK FOOTER //
// ./scripts/components/featured_article.js